<div class="new-purchase-guide-container">
    <h1>New Purchase Guide</h1>
    <mat-stepper [orientation]="(stepperOrientation | async)!" linear="true" #stepper>
        <mat-step [stepControl]="basicsForm" [editable]="isEditable">
            <form fxLayout="column" [formGroup]="basicsForm">
                <ng-template matStepLabel>Basics</ng-template>
                <h2>Add basic purchase details?</h2>
                <mat-form-field>
                    <mat-label>Asset Name</mat-label>
                    <input matInput placeholder="My Asset" formControlName="assetName">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput placeholder="Thinking about buying..." formControlName="description"></textarea>
                </mat-form-field>
                <mat-checkbox formControlName="exploring">Just exploring</mat-checkbox>
                <mat-form-field floatLabel="always">
                    <mat-label>Purchase Price</mat-label>
                    <input matInput currencyMask [options]="{precision:0}" placeholder="0"
                        formControlName="purchasePrice">
                </mat-form-field>
                <div>
                    <button mat-button matStepperNext color="primary" [disabled]="!basicsForm.valid">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="borrowingForm" [editable]="isEditable">
            <form fxLayout="column" [formGroup]="borrowingForm">
                <ng-template matStepLabel>Borrowing</ng-template>
                <h2>Add borrowing plans?</h2>
                <mat-form-field>
                    <mat-label>Bank</mat-label>
                    <input matInput placeholder="ANZ, Westpac, etc..." formControlName="bankName">
                </mat-form-field>
                <div fxLayout="row nowrap">
                    <mat-form-field floatLabel="always" class="new-purchase-form-element-large">
                        <mat-label>Deposit</mat-label>
                        <input *ngIf="borrowingForm.value.depositType === '%'" matInput type="number" placeholder="0"
                            class="new-purchase-guide-right-align" formControlName="depositValue">
                        <input *ngIf="borrowingForm.value.depositType !== '%'" matInput currencyMask
                            [options]="{precision:0}" placeholder="$100,000" formControlName="depositValue">
                        <mat-hint *ngIf="borrowingAmount">Borrowing: {{ borrowingAmount | currency }}</mat-hint>
                        <span *ngIf="borrowingForm.value.depositType === '%'" matTextSuffix>%</span>
                    </mat-form-field> &nbsp;
                    <mat-form-field style="width: 7.5rem;">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="depositType">
                            <mat-option value="percent">%</mat-option>
                            <mat-option value="amount">$</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row nowrap">
                    <mat-form-field class="new-purchase-form-element-large">
                        <mat-label>How long?</mat-label>
                        <input matInput type="number" formControlName="termValue">
                    </mat-form-field>&nbsp;
                    <mat-form-field style="width: 7.5rem;">
                        <mat-label>Units</mat-label>
                        <mat-select formControlName="termUnit">
                            <mat-option value="y">Years</mat-option>
                            <mat-option value="m">Months</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <mat-form-field>
                    <mat-label>Loan Start</mat-label>
                    <input matInput [matDatepicker]="loanStartPicker" formControlName="loanStart">
                    <mat-datepicker-toggle matIconSuffix [for]="loanStartPicker"></mat-datepicker-toggle>
                    <mat-datepicker #loanStartPicker></mat-datepicker>
                </mat-form-field>
                <div>
                    <button mat-button matStepperPrevious color="accent">Back</button>
                    <button mat-button matStepperNext color="primary" [disabled]="!borrowingForm.valid">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="loanDetailsForm" [editable]="isEditable">
            <ng-template matStepLabel>Loan Details</ng-template>
            <h2>Add loan instruments?</h2>
            <span>Allocated {{allocatedBorrowing | currency}} of {{borrowingAmount | currency}} borrowing using
                {{instrumentCount}} instrument/s.</span>
            <div [formGroup]="loanDetailsForm">
                <ng-container formArrayName="instruments">
                    <ng-container *ngFor="let instForm of instrumentsForms.controls; let i = index">
                        <div [formGroup]="instForm" fxLayout="row wrap">
                            <div>
                                <mat-form-field floatLabel="always"
                                    class=" new-purchase-form-element-spacer new-purchase-form-element-medium">
                                    <mat-label>Principal</mat-label>
                                    <input *ngIf="getPincipalAllocationUnits(i) !== '%'" matInput currencyMask
                                        [options]="{precision:0}" placeholder="$100,000"
                                        formControlName="principalValue">
                                    <input *ngIf="getPincipalAllocationUnits(i) === '%'" matInput placeholder="100"
                                        formControlName="principalValue" class="new-purchase-guide-right-align">
                                    <mat-hint>{{getPrincipalAlternateDisplay(i)}}</mat-hint>
                                    <span matTextSuffix *ngIf="getPincipalAllocationUnits(i) === '%'">%</span>
                                </mat-form-field>
                                <mat-form-field
                                    class="new-purchase-form-element-spacer new-purchase-form-element-medium">
                                    <mat-label>Method</mat-label>
                                    <mat-select formControlName="principalType">
                                        <mat-option value="percent">Percent</mat-option>
                                        <mat-option value="amount">Amount</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field
                                    class="new-purchase-form-element-spacer new-purchase-form-element-medium">
                                    <mat-label>Loan Type</mat-label>
                                    <mat-select formControlName="loanType">
                                        <mat-option value="fixed">Fixed</mat-option>
                                        <mat-option value="floating">Floating</mat-option>
                                        <mat-option value="revolving">Revolving Credit</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field floatLabel="always"
                                    class="new-purchase-form-element-spacer new-purchase-form-element-medium">
                                    <mat-label>Rate</mat-label>
                                    <input matInput type="number" placeholder="5.25"
                                        class="new-purchase-guide-right-align" formControlName="rate">
                                    <span matTextSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <mat-form-field class="new-purchase-form-element-medium">
                                <mat-label>Payments</mat-label>
                                <mat-select formControlName="pmtFreq">
                                    <mat-option value="m">Monthly</mat-option>
                                    <mat-option value="f">Fortnightly</mat-option>
                                    <mat-option value="w">Weekly</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div>
                                <mat-form-field
                                    class="new-purchase-form-element-spacer new-purchase-form-element-medium">
                                    <mat-label>Term</mat-label>
                                    <input matInput type="number" formControlName="termValue">
                                </mat-form-field>
                                <mat-form-field class="new-purchase-form-element-medium">
                                    <mat-label>Term Type</mat-label>
                                    <mat-select formControlName="termUnit">
                                        <mat-option value="y">Years</mat-option>
                                        <mat-option value="m">Months</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <button mat-icon-button color="warn"
                                    aria-label="Delete button with a trash can with a cross on it"
                                    (click)="onDeleteInstrument(i)">
                                    <mat-icon>delete_forever</mat-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <div fxLayoutAlign="center">
                    <button mat-mini-fab color="primary" (click)="onAddInstrument()"
                        [disabled]="borrowingAmount <= allocatedBorrowing">
                        <mat-icon class="add-course-btn">add</mat-icon>
                    </button>
                </div>
                <div>
                    <button mat-button matStepperPrevious color="accent">Back</button>
                    <button mat-button matStepperNext color="primary"
                        [disabled]="borrowingAmount !== allocatedBorrowing || !loanDetailsForm.valid">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step [editable]="isEditable">
            <ng-template matStepLabel>Confirmation</ng-template>
            <h2>Read to go?</h2>
            <div>
                <h3>Key Details</h3>
            </div>
            <div fxLayout="row wrap">
                <div class="confirmation-data-element">
                    <div>{{basicsForm.value.assetName}}</div>
                    <div><small>Asset Name</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div>{{basicsForm.value.exploring === true ? 'Yes' : 'No'}}</div>
                    <div><small>Just Exploring?</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div>{{basicsForm.value.purchasePrice | currency}}</div>
                    <div><small>Purchase Price</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div>{{borrowingForm.value.bankName ? borrowingForm.value.bankName : 'Not specified'}}</div>
                    <div><small>Bank</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div>{{depositAmount | currency}}</div>
                    <div><small>Deposit</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div *ngIf="borrowingForm.value.termValue === 1">{{borrowingForm.value.termValue}}
                        {{borrowingForm.value.termUnit === 'y' ? 'Year' : 'Month'}}</div>
                    <div *ngIf="borrowingForm.value.termValue !== 1">{{borrowingForm.value.termValue}}
                        {{borrowingForm.value.termUnit === 'y' ? 'Years' : 'Months'}}</div>
                    <div><small>Term</small></div>
                </div>
                <div class="confirmation-data-element">
                    <div>{{borrowingForm.value.loanStart | amDateFormat:'LL'}}</div>
                    <div><small>Loan Commence</small></div>
                </div>
            </div>
            <div>
                <h3>Instruments</h3>
            </div>
            <div fxLayout="row wrap">
                <div fxLayout="column nowrap" class="confirmation-instrument-container">
                    <div>Fixed ({{getInstrumentFormsByType('fixed').length}})</div>
                    <ng-container *ngFor="let fixed of getInstrumentFormsByType('fixed')">
                        <div fxLayout="row wrap">
                            <div class="confirmation-data-element">
                                <div *ngIf="fixed.principalType === 'percent'">{{fixed.principalValue / 100 | percent:
                                    '1.0-2'}}</div>
                                <div *ngIf="fixed.principalType !== 'percent'">{{fixed.principalValue | currency}}</div>
                                <div><small>Principal Share</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div>{{fixed.rate / 100 | percent: '1.0-2'}}</div>
                                <div><small>Rate</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div *ngIf="fixed.pmtFreq === 'm'">Monthly</div>
                                <div *ngIf="fixed.pmtFreq === 'f'">Fortnightly</div>
                                <div *ngIf="fixed.pmtFreq === 'w'">Weekly</div>
                                <div><small>Payment Frequency</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div *ngIf="fixed.termValue === 1">{{fixed.termValue}} {{fixed.termUnit == 'y'? 'Year' :
                                    'Month'}}</div>
                                <div *ngIf="fixed.termValue !== 1">{{fixed.termValue}} {{fixed.termUnit == 'y'? 'Years'
                                    : 'Months'}}</div>
                                <div><small>Term</small></div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="getInstrumentFormsByType('fixed').length === 0" class="confirmation-data-element">
                        No Fixed Term instruments.
                    </div>
                </div>
                <div fxLayout="column nowrap" class="confirmation-instrument-container">
                    <div>Floating ({{getInstrumentFormsByType('floating').length}})</div>
                    <ng-container *ngFor="let floating of getInstrumentFormsByType('floating')">
                        <div fxLayout="row wrap">
                            <div class="confirmation-data-element">
                                <div *ngIf="floating.principalType === 'percent'">{{floating.principalValue / 100 |
                                    percent: '1.0-2'}}</div>
                                <div *ngIf="floating.principalType !== 'percent'">{{floating.principalValue | currency}}
                                </div>
                                <div><small>Principal Share</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div>{{floating.rate / 100 | percent: '1.0-2'}}</div>
                                <div><small>Rate</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div *ngIf="floating.pmtFreq === 'm'">Monthly</div>
                                <div *ngIf="floating.pmtFreq === 'f'">Fortnightly</div>
                                <div *ngIf="floating.pmtFreq === 'w'">Weekly</div>
                                <div><small>Payment Frequency</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div *ngIf="borrowingForm.value.termValue === 1">{{borrowingForm.value.termValue}}
                                    {{borrowingForm.value.termUnit === 'y' ? 'Year' : 'Month'}}</div>
                                <div *ngIf="borrowingForm.value.termValue !== 1">{{borrowingForm.value.termValue}}
                                    {{borrowingForm.value.termUnit === 'y' ? 'Years' : 'Months'}}</div>
                                <div><small>Term</small></div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="getInstrumentFormsByType('floating').length === 0" class="confirmation-data-element">
                        No Floating Rate instruments.
                    </div>
                </div>
                <div fxLayout="column nowrap" class="confirmation-instrument-container">
                    <div>Revolving Credit ({{getInstrumentFormsByType('revolving').length}})</div>
                    <ng-container *ngFor="let revolving of getInstrumentFormsByType('revolving')">
                        <div fxLayout="row wrap">
                            <div class="confirmation-data-element">
                                <div *ngIf="revolving.principalType === 'percent'">{{revolving.principalValue / 100 |
                                    percent: '1.0-2'}}</div>
                                <div *ngIf="revolving.principalType !== 'percent'">{{revolving.principalValue |
                                    currency}}</div>
                                <div><small>Principal Share</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div>{{revolving.rate / 100 | percent: '1.0-2'}}</div>
                                <div><small>Rate</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div>Daily / Variable</div>
                                <div><small>Payment Frequency</small></div>
                            </div>
                            <div class="confirmation-data-element">
                                <div *ngIf="borrowingForm.value.termValue === 1">{{borrowingForm.value.termValue}}
                                    {{borrowingForm.value.termUnit === 'y' ? 'Year' : 'Month'}}</div>
                                <div *ngIf="borrowingForm.value.termValue !== 1">{{borrowingForm.value.termValue}}
                                    {{borrowingForm.value.termUnit === 'y' ? 'Years' : 'Months'}}</div>
                                <div><small>Term</small></div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="getInstrumentFormsByType('revolving').length === 0" class="confirmation-data-element">
                        No Revolving Credit instruments.
                    </div>
                </div>
            </div>
            <div>
                <button mat-button matStepperPrevious color="accent">Back</button>
                <button mat-raised-button color="primary" (click)="onDoIt(stepper)">Do it!</button>
            </div>
        </mat-step>
        <mat-step [editable]="isReadyToCreate">
            <ng-template matStepLabel>Done</ng-template>
            <h2>Setting up new purchase</h2>
            <p>Please wait while we setup your new purchase.</p>
            <div>
                <mat-list role="list">
                    <mat-list-item role="listitem" *ngFor="let item of itemsToCreate">
                        <div fxLayout="row nowrap">
                            <mat-spinner *ngIf="item.status === 'processing'" diameter="20"></mat-spinner>
                            <mat-icon *ngIf="item.status !== 'processing'" [ngClass]="getCreateItemCss(item.status)"
                                disableRipple="true">{{getCreateItemIcon(item.status)}}</mat-icon>
                            <div *ngIf="item.itemType === 'asset'">Asset '{{basicsForm.value.assetName}}' purchased for
                                {{((basicsForm.value.purchasePrice ?
                                basicsForm.value.purchasePrice : 0)) | currency}}</div>
                            <div *ngIf="item.itemType === 'debt'">Debt of
                                {{((basicsForm.value.purchasePrice ?
                                basicsForm.value.purchasePrice : 0) - (depositAmount ? depositAmount : 0)) | currency}}
                                to
                                purchase '{{basicsForm.value.assetName}}'</div>
                            <div *ngIf="item.itemType === 'instrument'">
                                {{getInstrumentLoanTypeDisplay(item.index)}} instrument of
                                {{getPrincipalAmount(item.index) | currency}} at {{getInstrumentRate(item.index) |
                                percent : '1.0-2'}}</div>
                        </div>
                    </mat-list-item>
                </mat-list>
            </div>
            <div>
                <button mat-raised-button color="primary" [disabled]="!isFinished"
                    [routerLink]="['/dashboard']">Finished</button>
            </div>
        </mat-step>
    </mat-stepper>
</div>